import { render, staticRenderFns } from "./horizontalItem.vue?vue&type=template&id=3ed9a180&scoped=true&"
import script from "./horizontalItem.vue?vue&type=script&lang=js&"
export * from "./horizontalItem.vue?vue&type=script&lang=js&"
import style0 from "./horizontalItem.vue?vue&type=style&index=0&id=3ed9a180&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed9a180",
  null
  
)

export default component.exports